import { BILLING_DETAILS_TEXTS, BILLING_DETAILS_TEST_ID } from './billing-details.constants';

export const isInternational = countryCode => countryCode !== 'BRA';

export function buildPropsByCountry(model, errors, onChange) {
    const {
        zipCode, taxNumber, cep, cnpj, countryCode,
    } = model;

    const {
        cep: errorCep, cnpj: errorCnpj, zipCode: errorZipCode, taxNumber: errorTaxNumber,
    } = errors;

    const isEditing = !!model.id;

    const nationalityProps = {
        international: {
            fieldOne: {
                label: BILLING_DETAILS_TEXTS.POSTAL_CODE,
                value: zipCode,
                onChange: value => onChange({ ...model, zipCode: value }),
                error: errorZipCode,
                maxLength: 10,
            },
            fieldTwo: {
                label: BILLING_DETAILS_TEXTS.TAX_NUMBER,
                value: taxNumber,
                onChange: value => onChange({ ...model, taxNumber: value }),
                error: errorTaxNumber,
                mask: '999-99-9999',
                placeholder: '___-__-____',
                disabled: isEditing,
                dataTestId: BILLING_DETAILS_TEST_ID.TAX_NUMBER,
            },
        },
        national: {
            fieldOne: {
                label: BILLING_DETAILS_TEXTS.CEP,
                value: cep,
                onChange: value => onChange({ ...model, cep: value }),
                error: errorCep,
                mask: '99999-999',
                placeholder: '_____-___',
            },
            fieldTwo: {
                label: BILLING_DETAILS_TEXTS.CNPJ,
                value: cnpj,
                onChange: value => onChange({ ...model, cnpj: value }),
                error: errorCnpj,
                mask: '99.999.999/9999-99',
                placeholder: '__.___.___/____-__',
                disabled: isEditing,
                dataTestId: BILLING_DETAILS_TEST_ID.CNPJ,
            },
        },
    };

    const { fieldOne, fieldTwo } = isInternational(countryCode)
        ? nationalityProps.international
        : nationalityProps.national;

    return { fieldOne, fieldTwo };
}

export const formatModel = (model) => {
    if (isInternational(model.countryCode)) {
        return {
            ...model,
            cep: null,
            cnpj: null,
            cityCode: null,
            stateCode: null,
        };
    }
    return {
        ...model,
        taxNumber: null,
        zipCode: null,
    };
};
